<template>
  <artisio-modal :visible="show" :title="title" body-class="pdf-modal" size="xl" hide-footer :content-in-form="false"
                 @hidden="hideModal" @show="onShow">
    <div class="data-wrapper" v-if="file" :key="`file-embed-${file.uuid}`">
      <spinner v-if="loading" :show="loading" :height="15"/>
      <template v-else>
        <b-img v-if="file.content_type.includes('image/')" fluid :src="file.url"/>
        <b-embed v-else :src="getSrc(file)"/>
      </template>
    </div>
  </artisio-modal>
</template>

<script>
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import Spinner from "@/core/components/common/Spinner";
  import Template from "@/modules/setup/templates/Templates";

  const {mapState, mapActions} = createNamespacedHelpers('attachments');

  export default {
    name: "AttachmentViewModal",
    components: {Template, Spinner, ArtisioModal},
    data() {
      return {
        loading: false,
        interval: null
      }
    },
    computed: {
      ...mapState({
        show: state => state.viewModal.show,
        file: state => state.viewModal.file,
      }),
      title() {
        return this.file ? this.file.name : ''
      }
    },
    methods: {
      ...mapActions(['hideViewModal', 'getAttachment', 'updateViewModalFile', 'updateFileInList']),
      hideModal() {
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
        this.loading = false;
        this.hideViewModal();
      },
      onShow() {
        this.checkForUploaded();
      },
      checkForUploaded() {
        // If file is not uploaded to 3rd party, check once in 2 seconds 5 times if is is uploaded
        if (this.file.uuid && !this.file.uploaded) {
          this.loading = true;
          let counter = 0;
          this.interval = setInterval(async () => {
            counter++;
            let response = await this.getAttachment(this.file.uuid);
            if (response.success) {
              if (response.body.uploaded) {
                this.updateViewModalFile(response.body);
                this.updateFileInList(response.body);
                clearInterval(this.interval);
                this.loading = false;
              }
            }
            if (counter === 5) {
              this.$errorDialog(this.$i18n.t("Your file is still being uploaded. Please, try again later."))
              this.hideModal();
              clearInterval(this.interval);
            }
          }, 2000)
        }
      },
      getSrc(file) {
        if (this.needGoogleUrl(file.content_type)) {
          return `https://docs.google.com/gview?url=${file.url}&embedded=true`;
        }
        return file.url;
      },
      needGoogleUrl(contentType) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
        const formats = [
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.oasis.opendocument.presentation',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'application/vnd.ms-powerpoint',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.oasis.opendocument.spreadsheet'
        ]
        return formats.includes(contentType);
      }
    },
  }
</script>

<style lang="scss">
</style>
